import UnhandledErrorModal from './unhandled-error-modal';
import './unhandled-error-modal.scss';

export default UnhandledErrorModal;
